import {AttrsSchema, Component} from 'panel';

import * as colors from 'common/util/colors';
import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {TooltipBulletStyle, TooltipItemType, TooltipSection} from './types';
import {template} from './template';
import css from './index.styl?inline';

export type ChartTooltipAttrs = {
  sections: TooltipSection[];
  'footer-text'?: string;
  'is-compact'?: boolean;
  'title-color'?: string;
};

export interface ChartTooltipJsxProps {
  attrs: ChartTooltipAttrs;
}

export class ChartTooltip extends Component<EmptyObj, ChartTooltipAttrs> {
  static get attrsSchema(): AttrsSchema<ChartTooltipAttrs> {
    return {
      ...super.attrsSchema,
      'footer-text': {type: `string`},
      'is-compact': {type: `boolean`, description: `set to True if using in a 1x1 dashboard card`},
      sections: {
        type: `json`,
        description: `interface: TooltipSection[]`,
      },
      'title-color': {type: `string`},
    };
  }

  get config() {
    return {
      template,
      useShadowDom: true,
      css,
      helpers: {
        TooltipItemType,
        getItemBackground: (item) => {
          const {bulletStyle, bulletColor} = item;
          return bulletStyle === TooltipBulletStyle.Solid
            ? {background: bulletColor}
            : {
                'background-image': `repeating-linear-gradient(-45deg, ${bulletColor}, ${bulletColor} 25%, ${colors.gray0} 25%, ${colors.gray0} 50%, ${bulletColor} 50%)`,
                'background-size': `4px 4px`,
              };
        },
      },
    };
  }
}

export const ChartTooltipEl = defineAndMakeJsxFactory<ChartTooltipJsxProps>(`mp-chart-tooltip`, ChartTooltip);
